import {
  ENTITLEMENT_WINDOW_LOADING,
  ENTITLEMENT_WINDOW_FAILURE,
  ENTITLEMENT_WINDOW_SUCCESS,
  ENTITLEMENT_REVIEW_WINDOW_FORM_CONTACTS_LOOKUPS_SUCCESS,
} from '../constants';

const initialState = {
  loading: false,
  data: [],
  contactList: [],
  error: null,
  successCount: 0,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ENTITLEMENT_WINDOW_LOADING:
      return {
        ...state,
        loading: true,
      };
    case ENTITLEMENT_WINDOW_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
        successCount: state.successCount + 1,
      };
    case ENTITLEMENT_WINDOW_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ENTITLEMENT_REVIEW_WINDOW_FORM_CONTACTS_LOOKUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        contactList: action.payload.contactList || [],
      };
    default:
      return state;
  }
}
